import { render, staticRenderFns } from "./WorkscheduleIpros.vue?vue&type=template&id=364d7823"
import script from "./WorkscheduleIpros.vue?vue&type=script&lang=js"
export * from "./WorkscheduleIpros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports